export const importNewList = {
	title: "Importar nueva lista de invitados",
	secondTitle: "Importar lista nueva o existente",
	middleTitle: "Para importar una nueva lista solo debe subir una hoja de cálculo",
	format: "Formato de la hoja de cálculo",
	altText: "Ejemplo de cómo debe estar estructurada la hoja de cálculo a importar",
	sheetFileName: "Lista de invitados",
	errorMessageDefault:
		"Hoja de cálculo inválida, descárguela nuevamente y haga los cambios necesarios. En caso de líneas vacías en rojo, elimínelas e intente nuevamente.",
	importList: "Importe una lista existente para este evento",
	selectText: "Importar lista del Local tal para este evento",
	relationUsers: "Clientes que serán agregados a la lista",
	error: "Error",
	list: "Lista",
	message: "Mensaje",
	form: {
		listName: "Nombre de la lista",
		colorSelect: "Asignar un color",
		expiresAtDate: "Expiración de la lista",
		at: "a las",
		errorName: "Ingrese el nombre de la lista",
		errorExpires: "Fecha y hora expirada.",
		couvertPercentage: "Descuento en el cover",
		entranceIds: {
			label: "Entrada asociada",
			placeholder: "Seleccione el tipo de entrada asociada",
		},
		description: {
			label: "Descripción",
			placeholder: "Agregue una observación para su lista si lo desea",
			limit: "Quedan {{count}} caracteres",
		},
		documentIsRequired: "Documento es obligatorio",
		canBeInvitedByLink: "Compartir lista vía link",
		addGuestTimeLimit: "Plazo límite de inserción de invitados",
	},
	successMessage: "Hoja de cálculo importada con éxito",
	alert:
		"Antes de importar la hoja de cálculo, asegúrese de que todas las líneas en blanco sean eliminadas",
	goBackText: "Volver a listas",
	or: "o",
	goBackModal: {
		title: "Salir",
		leavePage: "Salir de la página",
		description:
			"Al salir de esta página perderá toda la información completada, ¿desea salir de todos modos?",
	},
};
